/* Kun Shafi — Dawn build · brand behaviours
   1) Offer strip countdown (UTC deadline; hides on expiry + sets html.kn-offer-ended)
   2) Pack Size "Save 5%/7%" badges on Dawn's variant pills (re-applied after
      Dawn's section re-renders on variant change)
   3) Wishlist: localStorage hearts on cards, header count, /pages/wishlist grid */
(function () {
  'use strict';

  // ---------------- 1. Offer countdown ----------------
  function parseEnd(raw) {
    if (!raw) return null;
    raw = String(raw).trim();
    var m = raw.replace(' ', 'T').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
    if (!m) {
      var d = new Date(raw);
      return isNaN(d.getTime()) ? null : d.getTime();
    }
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  var KN_WEEK = 604800000;
  function initOffer(el) {
    if (el.__knOfferInit) return;
    el.__knOfferInit = true;
    var mode = (el.getAttribute('data-kn-offer-mode') || 'fixed').toLowerCase();
    var end = parseEnd(el.getAttribute('data-kn-offer-end'));
    var count = el.querySelector('[data-kn-offer-count]');
    if (!count || (mode !== 'rolling' && !end)) { el.hidden = true; return; }
    function tick() {
      var left = mode === 'rolling' ? (KN_WEEK - (Date.now() % KN_WEEK)) : (end - Date.now());
      if (left <= 0) {
        el.hidden = true;
        document.documentElement.classList.add('kn-offer-ended');
        clearInterval(timer);
        applyPreview();
        return;
      }
      el.hidden = false;
      var d = Math.floor(left / 86400000);
      var h = Math.floor((left % 86400000) / 3600000);
      var mnt = Math.floor((left % 3600000) / 60000);
      var s = Math.floor((left % 60000) / 1000);
      count.textContent = pad(d) + 'd ' + pad(h) + 'h ' + pad(mnt) + 'm ' + pad(s) + 's';
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  // ---------------- 2. Pack Save badges + price preview ----------------
  // Percentages come from theme settings (Kun Shafi - Offer & Packs) and ride on the
  // offer strip as data-kn-pack2 / data-kn-pack3. They must match the real
  // "Pack of 2" / "Pack of 3" automatic discounts in Admin > Discounts.
  function packSource() { return document.querySelector('[data-kn-pack2]'); }
  function packConfig() {
    var src = packSource();
    if (!src) return null;
    var cfg = {
      1: parseFloat(src.getAttribute('data-kn-pack1')) || 0,
      2: parseFloat(src.getAttribute('data-kn-pack2')) || 0,
      3: parseFloat(src.getAttribute('data-kn-pack3')) || 0
    };
    return (cfg[1] || cfg[2] || cfg[3]) ? cfg : null;
  }
  function packQty(value) {
    var v = String(value || '').trim().toLowerCase();
    if (v === 'pack of 2' || v === '2 pack' || v === 'pack of two') return 2;
    if (v === 'pack of 3' || v === '3 pack' || v === 'pack of three') return 3;
    return 1;
  }
  function eachPackFieldset(root, fn) {
    (root || document).querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (legend && /pack\s*size/i.test(legend.textContent)) fn(fs);
    });
  }
  function offerEnded() { return document.documentElement.classList.contains('kn-offer-ended'); }

  function badgePills(root) {
    var cfg = packConfig();
    if (!cfg) return;
    eachPackFieldset(root, function (fs) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = fs.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
        if (!label || label.querySelector('.kn-pack-save')) return;
        var qty = packQty(input.value);
        var pct = qty > 1 ? cfg[qty] : 0;
        if (pct > 0) {
          var sp = document.createElement('span');
          sp.className = 'kn-pack-save';
          sp.textContent = 'Save ' + pct + '%';
          label.appendChild(sp);
        }
      });
    });
  }

  // Show the price the customer will actually be charged once the automatic pack
  // discount applies, instead of the undiscounted variant price.
  var previewBusy = false;
  function knMoney(cents, iso, showIso) {
    var n = cents / 100, s;
    try { s = new Intl.NumberFormat('en-US', { style: 'currency', currency: iso }).format(n); }
    catch (e) { s = '$' + n.toFixed(2); }
    return showIso ? s + ' ' + iso : s;
  }
  function selectedPct() {
    var cfg = packConfig();
    if (!cfg || offerEnded()) return 0;
    var pct = 0;
    eachPackFieldset(document, function (fs) {
      var c = fs.querySelector('input[type="radio"]:checked');
      if (c) pct = cfg[packQty(c.value)] || 0;
    });
    return pct;
  }
  function applyPreview() {
    var src = packSource();
    if (!src) return;
    var wrap = document.querySelector('.product__info-container .price') ||
               document.querySelector('.product__info-wrapper .price');
    var vj = document.querySelector('[data-selected-variant]');
    if (!wrap || !vj) return;
    var v;
    try { v = JSON.parse(vj.textContent); } catch (e) { return; }
    if (!v || v.price == null) return;
    var total = Math.round(v.price * (100 - selectedPct()) / 100);
    var saleEl = wrap.querySelector('.price__sale .price-item--sale');
    var regEl = wrap.querySelector('.price__regular .price-item--regular');
    var target = (wrap.classList.contains('price--on-sale') && saleEl) ? saleEl : regEl;
    if (!target) return;
    var txt = knMoney(total, src.getAttribute('data-kn-iso') || 'USD', src.getAttribute('data-kn-cc') === '1');
    if (target.textContent.trim() === txt) return;
    previewBusy = true;
    target.textContent = txt;
    setTimeout(function () { previewBusy = false; }, 0);
  }
  function initPackPreview() {
    var host = document.querySelector('.product__info-container');
    if (!host || host.__knPreview || !packSource()) return;
    host.__knPreview = true;
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('fieldset.product-form__input input[type="radio"]')) {
        setTimeout(applyPreview, 120);
        setTimeout(applyPreview, 500);
      }
    }, true);
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (previewBusy) return;
        applyPreview();
      }).observe(host, { childList: true, subtree: true, characterData: true });
    }
    applyPreview();
  }

  // ---------------- 3. Wishlist ----------------
  var WKEY = 'knWishlist';
  function wishGet() {
    try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; }
  }
  function wishSet(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
    updateHeaderCount();
  }
  function wishHas(handle) { return wishGet().indexOf(handle) !== -1; }
  function wishToggle(handle) {
    var list = wishGet();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    wishSet(list);
    return i === -1;
  }
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.8-10-9.3C.4 8.6 2.3 4.9 6 4.3c2.2-.4 4.3.7 6 2.9 1.7-2.2 3.8-3.3 6-2.9 3.7.6 5.6 4.3 4 7.4-2.5 4.5-10 9.3-10 9.3z"/></svg>';

  function handleFromCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : null;
  }
  function initCardHearts(root) {
    (root || document).querySelectorAll('.card__media').forEach(function (media) {
      if (media.__knWish) return;
      var card = media.closest('.card-wrapper');
      if (!card) return;
      var handle = handleFromCard(card);
      if (!handle) return;
      media.__knWish = true;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kn-wish' + (wishHas(handle) ? ' is-on' : '');
      b.setAttribute('aria-label', 'Add to wishlist');
      b.setAttribute('aria-pressed', wishHas(handle) ? 'true' : 'false');
      b.innerHTML = HEART;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var on = wishToggle(handle);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      media.appendChild(b);
    });
  }

  function updateHeaderCount() {
    var b = document.querySelector('.kn-wish-bubble');
    if (!b) return;
    var n = wishGet().length;
    var sp = b.querySelector('span');
    if (sp) sp.textContent = n;
    b.style.display = n > 0 ? '' : 'none';
  }
  function initHeaderIcon() {
    if (document.querySelector('.kn-wish-link')) return;
    var cart = document.querySelector('#cart-icon-bubble');
    if (!cart) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'header__icon header__icon--cart link focus-inset kn-wish-link';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = '<span class="svg-wrapper" style="display:inline-flex;width:20px;height:20px">' + HEART + '</span><div class="cart-count-bubble kn-wish-bubble" style="display:none"><span aria-hidden="true">0</span></div>';
    var svg = a.querySelector('svg');
    svg.style.fill = 'none'; svg.style.stroke = 'currentColor'; svg.style.strokeWidth = '1.8';
    cart.parentNode.insertBefore(a, cart);
    updateHeaderCount();
  }

  function renderWishlistPage() {
    var root = document.getElementById('kn-wishlist-root');
    if (!root) return;
    var list = wishGet();
    if (!list.length) {
      root.innerHTML = '<div class="kn-wishlist-empty"><p>Your wishlist is empty.</p><a class="button" href="/collections/all">Browse products</a></div>';
      return;
    }
    root.innerHTML = '<div class="kn-wishlist-grid"></div>';
    var grid = root.firstChild;
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js').then(function (r) {
        if (!r.ok) throw new Error('gone');
        return r.json();
      }).then(function (p) {
        var card = document.createElement('a');
        card.className = 'kn-wishlist-card';
        card.href = p.url;
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        var price = (p.price / 100).toFixed(2);
        card.innerHTML =
          (img ? '<img src="' + img + '&width=420" alt="" loading="lazy" onerror="this.src=this.src.replace(\'&width=420\',\'\')">' : '') +
          '<div class="kn-wishlist-card__body"><p class="kn-wishlist-card__title">' + p.title + '</p>' +
          '<span class="kn-wishlist-card__price">$' + price + '</span></div>';
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'kn-wish is-on';
        rm.setAttribute('aria-label', 'Remove from wishlist');
        rm.innerHTML = HEART;
        rm.addEventListener('click', function (e) {
          e.preventDefault();
          wishToggle(handle);
          card.remove();
          if (!wishGet().length) renderWishlistPage();
        });
        card.appendChild(rm);
        grid.appendChild(card);
      }).catch(function () { /* product removed from store — skip */ });
    });
  }

  // ---------------- Sticky buy card (product page) ----------------
  function initStickyATC() {
    var buyBtns = document.querySelector('.product-form__buttons');
    var mainSubmit = document.querySelector('.product-form__submit');
    var qtyMain = document.querySelector('.product-form__input--quantity input[name="quantity"], input.quantity__input[name="quantity"]');
    var titleEl = document.querySelector('.product__title h1');
    if (!buyBtns || !mainSubmit || !titleEl || document.querySelector('.kn-sticky')) return;

    function imgSrc() {
      var t = document.querySelector('.thumbnail-list .thumbnail img') || document.querySelector('.product__media img');
      return t ? (t.currentSrc || t.src) : '';
    }
    function priceText() {
      var scope = document.querySelector('.product__info-wrapper') || document;
      var el = scope.querySelector('.price-item--sale.price-item--last, .price__sale .price-item--last') || scope.querySelector('.price-item--regular');
      return el ? el.textContent.trim() : '';
    }
    function variantText() {
      var vals = [];
      document.querySelectorAll('fieldset.product-form__input input[type="radio"]:checked').forEach(function (i) { vals.push(i.value); });
      return vals.join(' / ');
    }

    var wrap = document.createElement('div');
    wrap.className = 'kn-sticky';
    wrap.innerHTML =
      '<div class="kn-sticky__card">' +
        '<img class="kn-sticky__img" alt="" src="' + imgSrc() + '">' +
        '<div class="kn-sticky__info">' +
          '<p class="kn-sticky__title"></p>' +
          '<span class="kn-sticky__price"></span>' +
          '<div class="kn-sticky__variant"></div>' +
        '</div>' +
        '<span class="kn-sticky__qty">' +
          '<button type="button" data-kn-minus aria-label="Decrease quantity">&minus;</button>' +
          '<input type="number" min="1" value="1" aria-label="Quantity">' +
          '<button type="button" data-kn-plus aria-label="Increase quantity">+</button>' +
        '</span>' +
        '<button type="button" class="kn-sticky__add" aria-label="Add to cart">' +
          '<svg viewBox="0 0 24 24"><path d="M3 4h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.2L21 8H6"/><circle cx="10" cy="20.2" r="1.3"/><circle cx="17.5" cy="20.2" r="1.3"/></svg>' +
        '</button>' +
      '</div>' +
      '<button type="button" class="kn-sticky__top" aria-label="Back to top">' +
        '<svg viewBox="0 0 24 24"><path d="M12 19V6M6 12l6-6 6 6"/></svg>' +
      '</button>';
    document.body.appendChild(wrap);
    wrap.querySelector('.kn-sticky__title').textContent = titleEl.textContent.trim();

    var priceEl = wrap.querySelector('.kn-sticky__price');
    var varEl = wrap.querySelector('.kn-sticky__variant');
    var imgEl = wrap.querySelector('.kn-sticky__img');
    var qtyIn = wrap.querySelector('input');
    function sync() {
      priceEl.textContent = priceText();
      varEl.textContent = variantText();
      var s = imgSrc();
      if (s && imgEl.src !== s) imgEl.src = s;
    }
    sync();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('fieldset.product-form__input input[type="radio"]')) setTimeout(sync, 600);
    });

    wrap.querySelector('[data-kn-minus]').addEventListener('click', function () { qtyIn.value = Math.max(1, (parseInt(qtyIn.value) || 1) - 1); });
    wrap.querySelector('[data-kn-plus]').addEventListener('click', function () { qtyIn.value = (parseInt(qtyIn.value) || 1) + 1; });
    wrap.querySelector('.kn-sticky__add').addEventListener('click', function () {
      if (qtyMain) {
        qtyMain.value = Math.max(1, parseInt(qtyIn.value) || 1);
        qtyMain.dispatchEvent(new Event('change', { bubbles: true }));
      }
      mainSubmit.click();
    });
    wrap.querySelector('.kn-sticky__top').addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var pastBuy = !e.isIntersecting && e.boundingClientRect.top < 0;
          wrap.classList.toggle('is-on', pastBuy);
        });
      }, { threshold: 0 });
      io.observe(buyBtns);
    }
  }

  // ---------------- Social proof: daily sold count + live viewers ----------------
  function knSeed(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) h = ((h * 31) + str.charCodeAt(i)) >>> 0;
    return h;
  }
  function initSocialProof() {
    var box = document.querySelector('[data-kn-social]');
    if (!box || box.__knSocial) return;
    box.__knSocial = true;
    var handle = box.getAttribute('data-kn-handle') || 'kn';
    var now = new Date();
    var dayKey = handle + '-' + now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate();
    // sold: stable for the whole day, new number tomorrow (30-59)
    var soldEl = box.querySelector('[data-kn-sold]');
    var hrsEl = box.querySelector('[data-kn-sold-hours]');
    if (soldEl) soldEl.textContent = 30 + (knSeed(dayKey) % 30);
    if (hrsEl) hrsEl.textContent = 6 + (knSeed(dayKey + 'h') % 9);
    // viewers: random walk 30-59, retick every 5s with a soft fade
    var vEl = box.querySelector('[data-kn-viewers]');
    if (!vEl) return;
    var v = 30 + (knSeed(dayKey + 'v' + now.getHours()) % 30);
    vEl.textContent = v;
    setInterval(function () {
      var step = Math.floor(Math.random() * 8) - 3; // -3 .. +4
      v = Math.min(59, Math.max(30, v + (step === 0 ? 1 : step)));
      vEl.classList.add('kn-tick');
      setTimeout(function () {
        vEl.textContent = v;
        vEl.classList.remove('kn-tick');
      }, 250);
    }, 5000);
  }

  // ---------------- Product gallery arrows (desktop) ----------------
  function galleryArrows() {
    var mg = document.querySelector('media-gallery');
    if (!mg || mg.__knNav) return;
    var thumbs = mg.querySelectorAll('.thumbnail-list__item .thumbnail');
    if (thumbs.length < 2) return;
    mg.__knNav = true;
    var viewer = mg.querySelector('slider-component:not(.thumbnail-slider)') || mg;
    if (!viewer.style.position) viewer.style.position = 'relative';
    function go(dir) {
      var list = Array.prototype.slice.call(mg.querySelectorAll('.thumbnail-list__item .thumbnail'));
      var idx = -1;
      list.forEach(function (b, i) { if (b.getAttribute('aria-current') === 'true') idx = i; });
      if (idx === -1) idx = 0;
      var next = list[(idx + dir + list.length) % list.length];
      if (next) next.click();
    }
    ['prev', 'next'].forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kn-media-nav kn-media-nav--' + k;
      b.setAttribute('aria-label', k === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = k === 'prev' ? '&#8249;' : '&#8250;';
      b.addEventListener('click', function (e) { e.preventDefault(); go(k === 'prev' ? -1 : 1); });
      viewer.appendChild(b);
    });
  }

  // ---------------- boot ----------------
  function scan(root) {
    var r = root || document;
    if (!r.querySelectorAll) return;
    r.querySelectorAll('[data-kn-offer]').forEach(initOffer);
    badgePills(r);
    initCardHearts(r);
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }
  ready(function () {
    scan(document);
    initHeaderIcon();
    renderWishlistPage();
    galleryArrows();
    initSocialProof();
    initStickyATC();
    initPackPreview();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) scan(n);
          });
        });
      });
      mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  });
})();
